import { jsxs as c, jsx as l } from "react/jsx-runtime";
const i = ({ size: F = 24 }) => /* @__PURE__ */ c("svg", { width: F, viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l(
    "path",
    {
      d: "M594.944 0l335.12448 341.31968v563.2c0 65.9968-52.50048 119.48032-117.29408 119.48032H209.54624c-64.7936 0-117.2992-53.5296-117.2992-119.48032V119.48032C92.25216 53.48352 144.75776 0 209.55136 0H594.944z",
      fill: "#36D2AD"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      d: "M930.06848 341.31968h-211.9168c-64.74752 0-123.20768-59.48928-123.20768-125.4912V0l335.12448 341.31968z",
      fill: "#FFFFFF",
      fillOpacity: 0.4
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      d: "M613.56032 426.68032H278.4256c-10.24 0-18.61632 8.4736-18.61632 18.944V749.056c0 10.4704 8.37632 18.944 18.61632 18.944h335.1296c10.28608 0 18.61632-8.4736 18.61632-18.944V445.62432a18.80576 18.80576 0 0 0-18.61632-18.944z m-37.23776 284.39552H315.66848v-94.7712l55.8592-56.87296 93.08672 94.81216 55.8592-56.92416 55.84896 56.92416v56.87808-0.0512z m-37.23776-151.64416a37.56032 37.56032 0 0 1-37.23264-37.9392c0-20.9408 16.66048-37.93408 37.23264-37.93408 20.57728 0 37.23776 16.99328 37.23776 37.9392 0 20.9408-16.66048 37.93408-37.23776 37.93408z",
      fill: "#FFFFFF"
    }
  )
] });
export {
  i as ImageIcon
};
//# sourceMappingURL=ImageIcon.js.map
